import React, { useState } from 'react';
import Select from 'react-select';
import Header from './Heading';
import { domains } from '../configs/domains';
import Button from './Button';
import CSVService from '../Services/CSVService';
import GSCService from '../Services/GSCService';

const wrapperStyle = { backgroundColor: '#ddd', padding: '10px', border: '1px solid #444', margin: '10px' };

const reportTypes = [{
	value: 'interlinking',
	key: 'interlinking',
	label: 'Interlinking Opportunites'
}]
export default function ReportsSection({ }) {

	const [selectedDomain, setSelectedDomain] = useState(null);
	const [reportType, setReportType] = useState(null);

	return (<div style={wrapperStyle}>
		<div style={{ padding: "15px" }}>
			<Header text="Reports" type="h2" />
			<Select
				className="form-control border rounded"
				options={domains}
				value={domains.filter((option) => option.value === selectedDomain)}
				name={"domain"}
				id={"domain"}
				placeholder={"Domain"}
				onChange={(data) => { setSelectedDomain(data.value) }}
			/>
			<Select
				className="form-control border rounded"
				options={reportTypes}
				value={reportTypes.filter((option) => option.value === reportType)}
				name={"reportType"}
				id={"reportType"}
				placeholder={"Report Type"}
				onChange={(data) => { setReportType(data.value) }}
			/>
			<Button onClick={() => {
				console.log(selectedDomain);
				console.log(reportType);
				GSCService.query({
					siteUrl: `sc-domain:${selectedDomain}`,
					requestBody: {
						startDate: GSCService.getDateAsString(-30),
						endDate: GSCService.getDateAsString(-2),
						dimensions: ['query', 'page'],
						'rowLimit': 25000
					}
				}).then(result => {
					const rows = result.rows;
					const myMap = {};
					for (let row of rows) {
						if (row.keys[1].indexOf("#") > 0) continue;
						if (row.keys[0] in myMap) {
							myMap[row.keys[0]].push(row.keys[1])
						} else {
							myMap[row.keys[0]] = [row.keys[1]];
						}
					}
					const csv = [];
					for (let k of Object.keys(myMap)) {
						if (myMap[k].length > 1) {
							const item = {};
							item.Keyword = k;
							for (let i = 0; i < myMap[k].length; i++) {
								item[`url-${i + 1}`] = myMap[k][i];
							}
							csv.push(item);
						}
					}
					CSVService.generateCSV(csv);
				})
			}} text="Generate Report" disabled={!selectedDomain || !reportType} />
		</div>
	</div>)
}
